export const HEADER_ICONS = {
  none: {id: 'none' , icon: 'none'},
  separator: {id: 'separator' , icon: 'icon-separator'},
  like: {id: 'like' , icon: 'icon-like-full'},
  plus: {id: 'plus' , icon: 'icon-plus'},
  ampersand: {id: 'ampersand' , icon: 'icon-ampersand'},
  pipe: {id: 'pipe' , icon: 'icon-separator'},
  favorite: {id: 'favorite' , icon: 'icon-like-full'}
}
